import * as ExcelJS from 'exceljs';

// Function to add page numbers to all worksheets
export const addPageNumbersToWorkbook = (workbook: ExcelJS.Workbook) => {
  workbook.worksheets.forEach((worksheet) => {
    if (!worksheet.headerFooter) {
      worksheet.headerFooter = {};
    }
    
    worksheet.headerFooter.oddFooter = '&C&"Arial"- &P -';
    worksheet.headerFooter.evenFooter = '&C&"Arial"- &P -';
  });
};